import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=dc7b5132&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=dc7b5132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7b5132",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc7b5132')) {
      api.createRecord('dc7b5132', component.options)
    } else {
      api.reload('dc7b5132', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=dc7b5132&scoped=true&", function () {
      api.rerender('dc7b5132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22Uxsa3IFjmIX/JS/comp/GuestBox.vue"
export default component.exports